export default "__VITE_ASSET__KjysBpf7__"